import React from "react";
import PropTypes from "prop-types";
import useTranslation from "../hooks/use-translation";

function DecodedTranslation(props) {

    const options = {
        data: props.data,
        count: props.count
    };

    const translation = useTranslation(props.name, options, props.defaultValue);

    function generateDecodedNodes() {
        let e = document.createElement('div');
        e.innerHTML = replaceShortcodes(translation);
        let nodes = [];
        if (e.childNodes.length > 0) {
            for (let i = 0; i < e.childNodes.length; i++) {
                nodes.push(<span key={i} dangerouslySetInnerHTML={{__html: nodeToJSX(e.childNodes[i])}}/>);
            }
        }
        return nodes;
    }

    function replaceShortcodes(string) {

        //[[[[text]]]] -> <span class="text-highlight-4 >text</span>
        string = replaceShortcode(string, /(\[\[\[\[)(.*?)(\]\]\]\])/gm, 4);

        //[[[text]]] -> <span class="text-highlight-3 >text</span>
        string = replaceShortcode(string, /(\[\[\[)(.*?)(\]\]\])/gm, 3);

        //[[text]] -> <span class="text-highlight-2" >text</span>
        string = replaceShortcode(string, /(\[{2})(.*?)(\]{2})/gm, 2);

        //[text] -> <span class="text-highlight-1" >text</span>
        string = replaceShortcode(string, /(\[)(.*?)(\])/gm, 1);

        return string;
    }

    function getFormattedVal(val){
        if(val == "0" && props.replace_zero !== null){
            return props.replace_zero;
        }

        return val;
    }

    function replaceShortcode(string, regex, level) {
        let matches = string.match(regex);
        if (matches !== null && matches.length > 0) {
            for (let i = 0; i < matches.length; i++) {
                let match = matches[i];
                match = match.substring(level);
                match = match.substring(0, match.length - level);
                string = string.split(matches[i]).join('<span class="decoded-translation translation-shortcode-type-' + level + '" >' + getFormattedVal(match) + '</span>');
            }
        }

        return string;
    }

    function nodeToJSX(node) {
        if (typeof(node) === 'string') {
            return node;
        } else if (node.nodeName === '#text') {
            return node.textContent;
        } else if (typeof(node.outerHTML) !== 'undefined') {
            return node.outerHTML;
        }
        return node;
    }


    return (
        <span className={'decoded-translation ' + props.className} onClick={props.onClick}>
            <React.Fragment>
                {generateDecodedNodes()}
            </React.Fragment>
        </span>
    );
}

DecodedTranslation.defaultProps = {
    name: null,
    data: {},
    count: null,
    defaultValue: null,
    className: '',
    replace_zero: null,
}

DecodedTranslation.propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
    count: PropTypes.number,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    replace_zero: PropTypes.string,
}

export default DecodedTranslation;

